import {defineAbilityConfig} from '../system/defineAbilityConfig';

/**
 * Determines whether users can access AI features based on workspace-level settings
 * and the user's site permissions.
 *
 * Requires both:
 * 1. Workspace AI toggle enabled (copilotEnabled)
 * 2. User's effective site permissions grant siteAI.use
 *
 * @see https://webflow.atlassian.net/wiki/spaces/TS/pages/2194538522/AI+features+governance+developer+guide
 */
export const canAccessAIFeatures = defineAbilityConfig({
  features: {workspaceCopilotEnabled: true},
  permission: ['use', 'siteAI'],
} as const);

/**
 * Checks only the workspace AI toggle, without requiring siteAI.use permission.
 * Use only in select cases like gating preview mode, where the public role
 * lacks siteAI.use but the workspace toggle should still control visibility.
 */
export const isAIToggleEnabled = defineAbilityConfig({
  features: {workspaceCopilotEnabled: true},
} as const);
